import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

function InfoPopup({ content, onClose }) {
  const popupRef = useRef(null)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose() // Call the onClose function when ESC is pressed
      }
    }

    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose() // Close the popup when clicking outside
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  // Replace newlines or carriage returns with <br />
  const formattedContent = content.replace(/(?:\r\n|\r|\n|&#013;)/g, '<br>')

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[2200]">
      <div
        className="bg-white rounded-lg p-5 shadow-lg max-w-md mx-auto"
        style={{ maxHeight: '500px', overflowY: 'auto' }} // Limits the height and makes it scrollable
        ref={popupRef} // Attach ref to the popup container
      >
        <div className="text-right h-[30px]">
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800 font-bold"
          >
            X
          </button>
        </div>
        <div
          className="mt-2"
          style={{ maxHeight: '350px', overflowY: 'auto' }} // Content-specific scrolling
        >
          {/* Render formatted content as HTML */}
          <p dangerouslySetInnerHTML={{ __html: formattedContent }}></p>
        </div>
        <div className="text-right mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default InfoPopup
